/**
 * Current UI language, kept outside React so that non-React helpers
 * (for example enum label helpers) can read it synchronously.
 */

export type Lang = "cs" | "en";

export const SUPPORTED_LANGS: Lang[] = ["cs", "en"];

const STORAGE_KEY = "bridge.lang";

const readStoredLang = (): Lang => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === "en" ? "en" : "cs";
  } catch {
    // Private mode or blocked storage - fall back to Czech.
    return "cs";
  }
};

let currentLang: Lang = readStoredLang();

const listeners = new Set<(lang: Lang) => void>();

export const getLang = (): Lang => currentLang;

export const setLang = (lang: Lang): void => {
  if (lang === currentLang) return;
  currentLang = lang;

  try {
    window.localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // Storage is optional, the language still applies for this session.
  }

  document.documentElement.lang = lang;
  listeners.forEach((listener) => listener(lang));
};

export const subscribeLang = (listener: (lang: Lang) => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
